import useGetCurrentUser from '@/services/api/auth/useGetCurrentUser.js'
import useGetTeams from '@/services/api/team/useGetTeams.js'
import useAppStore from '@/store/useAppStore'
import useAuthStore from '@/store/useAuthStore'
import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

export default function PrivateRoute() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const location = useLocation()
  const { data: teams, status } = useGetTeams(isAuthenticated)
  const setCurrentTeamId = useAuthStore((state) => state.setCurrentTeamId)
  const currentTeamId = useAuthStore((state) => state.currentTeamId)
  const setNumberOfPeriods = useAppStore((state) => state.setNumberOfPeriods)
  const setPeriodType = useAppStore((state) => state.setPeriodType)
  useGetCurrentUser(isAuthenticated)

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (status === 'success' && teams.length > 0) {
      const defaultTeam = teams.find((team) => team.is_default)
      // const teamId = currentTeamId ?? defaultTeam?.id ?? null
      const deaultTeamID = defaultTeam?.id ?? null
      // is currentTeamId a valid selection
      const isCurrentTeamIdValid =
        teams.find((x) => x.id === currentTeamId) ?? false

      const activeTeamId = isCurrentTeamIdValid ? currentTeamId : deaultTeamID
      setCurrentTeamId(activeTeamId)

      // Sync period settings on first load only — prevents overriding the
      // user's manual TopBar selections if the teams query re-fires in the
      // background during a session.
      if (isLoading) {
        const activeTeam = teams.find((t) => t.id === activeTeamId)
        if (activeTeam?.default_horizon) {
          setNumberOfPeriods(activeTeam.default_horizon)
          setPeriodType(activeTeam.period_type.toLowerCase())
        }
      }

      setIsLoading(false)
    }
  }, [
    status,
    teams,
    currentTeamId,
    setCurrentTeamId,
    isLoading,
    setNumberOfPeriods,
    setPeriodType,
  ])

  if (!isAuthenticated)
    return <Navigate to="/login" state={{ from: location }} />

  if (status === 'success' && teams.length === 0)
    return <Navigate to="/setup" />

  if (status !== 'success' || isLoading) return <div>Loading</div>

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} />
  )
}
